module.exports = __webpack_public_path__ + "img/105027.d49acc4a.png";